export default __webpack_public_path__ + "static/media/closet1-768w.5179760f.png";